export function scrollItemToIndex(scrollingContainerRef, nextItemIndex) {
    // data-item-index attribute of a component should not be used since it is possible to have multiple
    // ItemWorkflowTables inside a single page.
    // const item = scrollingContainerRef.current?.querySelectorAll(`tr[data-item-index="${itemIndex}"]`)?.[0] as Element | undefined;
    // What is faster? To have attr (comment above) or to find by nth-child.
    const item = scrollingContainerRef.current?.querySelector(`tr:nth-child(${nextItemIndex + 1})`);
    item?.scrollIntoView({ block: 'center' });
}
